import gql from 'graphql-tag';

export const HIDE_STALL_PRODUCT = gql`
  mutation HideStallProduct($stallProductId: ID!, $hidden: Boolean!) {
    hideStallProduct(stallProductId: $stallProductId, hidden: $hidden) {
      success
      error
    }
  }
`;
